import { avatarBgClass, initialsFor } from "@/lib/avatarColor";

/** Avatar + name (bold) + email (muted) on a single line — fits h-12 table rows. */
export function UserIdentityCell({
  id,
  name,
  email,
}: {
  id: string;
  name?: string | null;
  email?: string | null;
}) {
  const hasName = !!name?.trim();
  return (
    <div className="flex items-center gap-2 min-w-0" title={hasName ? `${name} · ${email ?? ""}` : email ?? id}>
      <div
        className={`w-6 h-6 rounded-full ${avatarBgClass(id)} text-primary-foreground text-[10px] font-semibold flex items-center justify-center shrink-0`}
      >
        {initialsFor(name, email)}
      </div>
      {hasName ? (
        <span className="truncate text-sm">
          <span className="font-medium text-foreground">{name}</span>
          <span className="text-muted-foreground"> · {email}</span>
        </span>
      ) : (
        <span className="truncate font-medium text-sm">{email ?? id}</span>
      )}
    </div>
  );
}
